import { THEME } from '../../utils/theme';

const Badge = ({ children, color = THEME.textMuted, bg = THEME.bgElevated }) => (
  <span style={{
    display: 'inline-flex', alignItems: 'center', padding: '3px 8px', borderRadius: '6px',
    fontSize: '11px', fontWeight: '600', color, background: bg, letterSpacing: '0.3px'
  }}>{children}</span>
);

export default Badge;
